import { IDs } from '../../../../helpers/IDs';

export function checkKennzahlenPlausibel(row: any, data: any) {
    const plausibel: any = {};
    const gewerk = row.branchen_gewerke_tid_orig;
    const betriebliche_situation = row.betriebliche_situation;
    let daten = null;
    try {
        daten = JSON.parse(row.daten);
    } catch (e) {
        console.log('checkKennzahlenPlausibel: JSON-Error: ', e, row);
        plausibel.result_manual = false;
        plausibel.error = 'JSON';
        return plausibel;
    }
    const kz_agg = (data[IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION] || [])
        .filter((item: any) => (item.modus || 100) === 100 && !item.zeitraum && !item.jahr);
    const fact_max = 1.5;
    const fact_min = 0.5;
    let plausibel_result = true;
    let plausibel_result_manual = true;
    // console.log('checkKennzahlenPlausibel D: ', jahr, gewerk, betriebliche_situation, daten);
    // console.log('checkKennzahlenPlausibel A', kz_agg);
    daten.forEach((d: any) => {
        const kuerzel = d.kuerzel;
        let found = kz_agg.find((item: any) => !item.jahr && item.branchen_gewerke_tid_orig === gewerk && kuerzel === item.kuerzel);
        let plausi_quelle = 'Gewerk';
        let plausi_status = '';
        let wert_min = null;
        let wert_max = null;
        if (!found) {
            found = kz_agg
                .find((item: any) => !item.jahr && item.betriebliche_situation === betriebliche_situation && kuerzel === item.kuerzel);
            plausi_quelle = 'Cluster';
        }
        if (!found) {
            plausi_quelle = 'Nicht vorh.';
            plausibel_result = false;
            if (!d.ignore && !d.allow) {
                plausibel_result_manual = false;
            }
        } else {
            wert_min = found.wert_min * fact_min;
            wert_max = found.wert_max * fact_max;
            const wert = d.wert;
            if (wert_min > 0 && wert_max > 0) {
                if (wert && wert > 0 && wert > wert_min && wert < wert_max) {
                    plausi_status = 'ok';
                } else {
                    plausi_status = 'prüfen';
                    plausibel_result = false;
                    if (!d.ignore && !d.allow) {
                        plausibel_result_manual = false;
                    }
                }
            } else {
                plausi_status = 'nicht vorh.';
                plausibel_result = false;
            }
        }
        plausibel[kuerzel] = { plausi_quelle, plausi_status, wert_min, wert_max };
    });
    plausibel.result = plausibel_result;
    plausibel.result_manual = plausibel_result_manual;
    // console.log('Plausi', plausibel);
    return plausibel;
}
